<template>

  <div :class="['cube', {'is-double-sided':double}]" :style="{...boxPosition, transform:boxTranslate, width:getSize('width'), height:this.getSize('height')}">

      <div class="shape cuboid-1 cub-1" :style="{width:getSize('width'), height:this.getSize('height')}">
        <div class="face ft" :style="{transform: frontTransform}">
          <div class="photon-shader" :style="{background : this.getBoxTexture('front') }"></div>
        </div>
        <div class="face bk" :style="{transform: backTransform}">
          <div class="photon-shader" :style="{background : this.getBoxTexture('back')  }"></div>
        </div>
        <div class="face rt" :style="{width:this.getSize('depth'), height:this.getSize('height')}">
          <div class="photon-shader" :style="{background : this.getBoxTexture('right')  }"></div>
        </div>
        <div class="face lt" :style="{width:this.getSize('depth'), height:this.getSize('height')}">
          <div class="photon-shader" :style="{background : this.getBoxTexture('left')  }"></div>
        </div>
        <div class="face bm" :style="{height:this.getSize('depth'),width:getSize('width')}">
          <div class="photon-shader" :style="{background : this.getBoxTexture('bottom')  }"></div>
        </div>
        <div class="face tp" :style="{height:this.getSize('depth'),width:getSize('width')}">
          <div class="photon-shader" :style="{background : this.getBoxTexture('top')  }"></div>
        </div>
       
      </div>
      
  </div>

</template>

<script>

import { mapGetters } from 'vuex'
export default {

  name: 'Box',

  data:function(){
    return {
      unit:'em'
    }
  },

  props: ['name','dimensions', 'mod', 'defaultSides', 'double', 'sides', 'position','debug', 'position', 'offset', 'color'],

  methods:{

    getSize(dimension){

      if(typeof this.dimensions !== 'undefined' && this.dimensions.hasOwnProperty(dimension)){           
        return (this.dimensions[dimension] * this.factor) + this.unit;
      }

    },

    getBoxTexture(side){
      
      var keys = JSON.parse(JSON.stringify(this.combinedSchema[side]));
    
      var defaultKeys = (this.defaultSides && Object.entries(this.defaultSides).length > 0 && typeof this.defaultSides !== "undefined")? JSON.parse(JSON.stringify(this.defaultSides[side])) :  {};      
      
      if(keys){

        keys = (Array.isArray(keys))? keys : [keys];

        //Replace default value
        var index = keys.indexOf("default");
        if(~index){
          if (Array.isArray(defaultKeys)) {
            keys.splice(index, 1, ...defaultKeys);
          }else{
            keys.splice(index, 1, defaultKeys);
          }
        }

      }
 
      return this.getTextures(keys);

    }

  },


  computed:{

    ...mapGetters(['mediabank', 'stageSettings', 'getTexture', 'getTextures']),

    factor(){
      return this.stageSettings.stage_scale;
    },

    boxTranslate(){
      if(this.offset){
        return 'translate3D('+ (this.offset.x * this.factor) + this.unit + ',' + (this.offset.y * this.factor) + this.unit + ',' + (this.offset.z * this.factor) + this.unit + ')';
      }else{
        return 'translate3D(0,0,0)';
      }
    },

    combinedSchema(){
      return {...this.defaultSides, ...this.sides};
    },

    frontTransform(){        
      if(this.dimensions !== undefined){
        return 'translateZ(' + this.dimensions['depth']*this.factor / 2  + this.unit + ')'; 
      }
      else{
        return false;
      }
       
    },

    backTransform(){ 
      if(this.dimensions !== undefined){     
       return 'translateZ(-' + (this.dimensions['depth']*this.factor) / 2.05 + this.unit + ') rotateY(180deg)'; 
       }
      else{
        return false;
      }
    },

    getMargins(){     
      return `-${(this.dimensions.height * this.factor / 2) + this.unit} 0 0 -${(this.dimensions.width * this.factor / 2) + this.unit}`;
    },

    boxPosition(){
      
      if(this.position){

        var pos = {};
              
        for (var dim in this.position) {
          
          pos[dim] = (!isNaN(this.position[dim]))?(this.position[dim] * this.factor) + this.unit : this.position[dim];
        }

        pos['position'] = 'absolute';

        return pos;

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* /!\ You need to add vendor prefixes in order to render the CSS properly (or simply use http://leaverou.github.io/prefixfree/) /!\ */ 

.cube{
  position: relative;
  transform-style:preserve-3d;
  margin:0 auto;
  cursor:pointer;
}

.face{
  /* box-shadow: inset 0 0 100px rgba(220, 229, 248, 0.2), inset 0 0 1px 0px rgba(0, 0, 0, 0.2); */
}

.face > div{
  /* mix-blend-mode: difference; */
}


.shape, .face, .face-wrapper, .cr {
  position: absolute;
  transform-style: preserve-3d;
}

/* .shape {
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform-origin: 50%;
} */
.face, .face-wrapper {
  overflow: hidden;
  transform-origin: 0 0;
  backface-visibility: hidden;
  /* hidden by default, prevent blinking and other weird rendering glitchs */
}
.face {
  background-size: 100% 100%!important;
  background-position: center;

}

.cube:not(.feature):not(.top) .face.ft .photon-shader {
/* filter:brightness(100%); */
}
.cube:not(.feature) .face.tp .photon-shader{
  /* filter:brightness(80%); */
}


.module:not(:last-child) .cube.has-side-gaps .face.ft .photon-shader,
.module:not(:last-child) .cube.has-side-gaps .face.tp .photon-shader{

  border-right:1px solid rgba(0,0,0,0.4);
  
}

.module .cube.has-bottom-gaps .face.ft .photon-shader{
  border-bottom:1px solid rgba(22,22,22,1);
}


.cube.blendmode-color-burn .face{
  /* mix-blend-mode: color-burn;
  backface-visibility: visible; */
}
.cube.spacing .photon-shader{
   box-shadow: 0 0 0px 1px rgba(0,0,0,0.4) inset;
}
.cube.bevel .photon-shader{
  box-shadow:inset 0px 1px 1px 1px rgba(255,255,255,0.2);
}

.cube.spacing.bevel .photon-shader{
    box-shadow: 0px 1px 1px 0px rgba(255,255,255,0.2) inset;
    border-radius:3px;
    border-radius: 0 6px 0 0;
    border:2px solid rgba(0,0,0,0.4);
}


.face-wrapper .face {
  left: 100%;
  width: 100%;
  height: 100%;
  
  
  
}
.photon-shader {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  
}

.is-double-sided .face{
  /* backface-visibility: visible; */
  background:linear-gradient(to bottom right, white, #f1f1f1);
}

.side {
  left: 50%;
}
.cr, .cr .side {
  height: 100%;
}
[class*="cuboid"] .ft, [class*="cuboid"] .bk {
  width: 100%;
  height: 100%;

}
[class*="cuboid"] .bk {
  left: 100%;
}
[class*="cuboid"] .rt {
  transform: rotateY(-90deg) translateX(-49%);
}
[class*="cuboid"] .lt {
  transform: rotateY(90deg) translateX(-51%);
}
[class*="cuboid"] .tp {
  transform: rotateX(90deg) translateY(-49%);
}
[class*="cuboid"] .bm {
  transform: rotateX(-90deg) translateY(-50%);
}
[class*="cuboid"] .lt {
  left: 100%;
}
[class*="cuboid"] .bm {
  top: 100%;
}
/* .cub-1 styles */
.cub-1 {
 
  opacity:1;
  width:30em;
  height:1em;
  
}
.cub-1 .ft {
  transform:translateZ(5em);
}
.cub-1 .bk {
  transform:translateZ(-5em) rotateY(180deg);
}
.cub-1 .rt, .cub-1 .lt {
  width:10em;
  height:1em;
}
.cub-1 .tp, .cub-1 .bm {
  width:30em;
  height:10em;
}
.cub-1 .face {

}

</style>